export default "/app/themes/majeures/build/images/shape-bookmark.svg?9e142ad9be35f5a95fc2f470032e5d8e";